import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Location } from './locations.interfaces';

@Injectable({
  providedIn: 'root',
})
/**
 * Locations REST calls
 */
export class LocationsService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get all locations
   */
  getLocations(): Observable<Location[]> {
    const url = `${this.globals.apiRoot}/jwtlocations`;
    return this.http.get<Location[]>(url);
  }
}
